import { Loader } from 'rsuite';
import './index.css';

export default function LoaderComponent({ size='lg', content='Loading' }) {
  return (
    <div className="loader-fade-wrapper">
      <Loader data-testid="loader-component" style={{zIndex: 99999}} size={size} content={content} vertical backdrop center />
    </div>
  );
}